<template>
  <div class="ed-grid s-grid-4 m-grid-4 lg-grid-8 s-center">
    <section v-for="categoria in seven" :key="categoria.id">
      <img
        :src="categoria.imagen"
        :alt="categoria.categoria"
        class="categorias__imagen"
      />
      <p class="categorias__texto">{{ categoria.categoria }}</p>
    </section>
  </div>
</template>
<script>
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();

    const categorias = store.state.categorias.todasLasCategorias;

    let seven = [];

    function getRandomElements(arr) {
      while (seven.length < 8) {
        let randomIndex = Math.floor(Math.random() * arr.length);
        if (!seven.includes(arr[randomIndex])) {
          seven.push(arr[randomIndex]);
        }
      }
      return seven;
    }
    getRandomElements(categorias);

    return {
      categorias,
      seven,
    };
  },
};
</script>
<style scoped lang="scss">
@import "../../sass/home.scss";
</style>